import UploadSingleBatchUserForm from "./UploadSingleBatchUserForm";

export default UploadSingleBatchUserForm;



// WEBPACK FOOTER //
// ./src/features/score-card/components/upload-single-batch-user-form/index.js